import { IBaseModel } from '../base/base-model.interface';
import { createEnumOptions } from '../shared/enum-option.interface';

export enum NotificationSeverity {
  info = 'info',
  warn = 'warn',
  danger = 'danger',
}

export interface ICustomNotification extends IBaseModel<'CustomNotification'> {
  severity: NotificationSeverity;
  message: string;
  text: string;
  seenBy?: string[];
}

export const notificationSeverityOptions =
  createEnumOptions<NotificationSeverity>({
    [NotificationSeverity.info]: {
      label: 'Informácie',
      icon: 'info',
      color: 'primary',
    },
    [NotificationSeverity.warn]: {
      label: 'Upozornenie',
      icon: 'exclamation',
      color: 'warn',
    },
    [NotificationSeverity.danger]: {
      label: 'Nebezpečenstvo',
      icon: 'times',
      color: 'danger',
    },
    _default: { label: '-', icon: 'minus' },
  });
